/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Back_Tohome1Inputs */

const ja_back_tohome1 = /** @type {(inputs: Back_Tohome1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホームに戻る`)
};

const en_back_tohome1 = /** @type {(inputs: Back_Tohome1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to home`)
};

/**
* | output |
* | --- |
* | "Back to home" |
*
* @param {Back_Tohome1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const back_tohome1 = /** @type {((inputs?: Back_Tohome1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Back_Tohome1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_back_tohome1(inputs)
	return en_back_tohome1(inputs)
});
export { back_tohome1 as "back_toHome" }